import { useQueryClient } from '@tanstack/react-query';
import { Flex, Spin } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text } from 'components/mvp-typography';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';
import { useHistory } from 'react-router-dom';
import { ClinicianRoutePrefix } from 'routes';

export interface OrganisationOnboardingCompletionPageProps {
  /**
   * Label rendered on the primary "finish" button.
   * @default 'Finish'
   */
  finishLabel?: string;
  /**
   * When `true`, a loading spinner is rendered instead of the button.
   * @default false
   */
  loading?: boolean;
  /**
   * Optional callback invoked when the finish button is clicked. Provided by
   * Storybook as an action hook for observability.
   */
  finishOnClick?: () => void;
  orgId: string;
}

export function OrganisationOnboardingCompletionPage(
  props: OrganisationOnboardingCompletionPageProps
) {
  const { finishLabel = 'Finish', loading = false, finishOnClick } = props;
  const queryClient = useQueryClient();
  const history = useHistory();
  const handleFinish = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeyFactory.clinic.basicInfo(props.orgId)
    })
    history.push(ClinicianRoutePrefix); // Example navigation to clinician home
    finishOnClick?.();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        gap: 24
      }}
    >
      <Flex vertical gap={16} align="center" style={{ maxWidth: '50%' }}>
        <Text style={{ fontWeight: 'bold' }}>Thank you for joining ConcussionRx!</Text>
        <Text>
          We look forward to changing the face of concussion care and brain health, together.
        </Text>
        <div style={{ marginTop: '20px' }}>
          {loading ? <Spin /> : <BaseButton type="primary" onClick={handleFinish}>{finishLabel}</BaseButton>}
        </div>
      </Flex>
    </div>
  );
}

